module.exports = __webpack_public_path__ + "img/cancel.1ccf5d6c.svg";